import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import SelectInput from "../Builder/nodes/Logic/Inputs/SelectInput";
import CustomReportAllSelectInput from "./CustomReportAllSelectInput";
import CustomReportsMonitoringWidget from "../Common/widgets/CustomReportsMonitoringWidget";

const options = {
  status: [
    { value: "active", label: "Active" },
    { value: "draft", label: "Draft" },
    { value: "archived", label: "Archived" },
  ],
  ping_status: [
    { value: "ok", label: "OK" },
    { value: "failing", label: "Failing" },
    { value: "failed", label: "Failed" },
    { value: "recovering", label: "Recovering" },
    { value: "unknown", label: "Unknown" },
  ],
  priority: [
    { value: "high", label: "High" },
    { value: "medium", label: "Medium" },
    { value: "low", label: "Low" },
  ],
  kind: [
    { value: "weather", label: "Weather" },
    { value: "ping", label: "Ping" },
  ],
};

export default function CustomReportsMonitoringPickerModal({ show, onHide, onSelect, config }) {
  const [title, setTitle] = useState("Monitors");
  const [filters, setFilters] = useState({ status: [], ping_status: [], priority: [], kind: [], search: [""] });
  const [displayMode, setDisplayMode] = useState("table");
  const [groupBy, setGroupBy] = useState("status");

  useEffect(() => {
    if (!show) return;
    setTitle(config?.title || "Monitors");
    setFilters({ status: [], ping_status: [], priority: [], kind: [], search: [""], ...config?.filters });
    setDisplayMode(config?.displayMode || "table");
    setGroupBy(config?.groupBy || "status");
  }, [show, config]);

  const previewConfig = { title, filters, displayMode, groupBy };
  const setFilter = (name, value) => setFilters((current) => ({ ...current, [name]: value }));

  return (
    <Modal show={show} onHide={onHide} centered size="xl">
      <Modal.Header closeButton><Modal.Title>Configure Monitors</Modal.Title></Modal.Header>
      <Modal.Body>
        <div className="row g-4">
          <div className="col-lg-5"><div className="card-gradient rounded-3 overflow-hidden text-white" style={{ minHeight: 520 }}><CustomReportsMonitoringWidget {...previewConfig} /></div></div>
          <div className="col-lg-7">
            <Form.Group className="mb-3"><Form.Label>Widget title</Form.Label><Form.Control value={title} onChange={(event) => setTitle(event.target.value)} maxLength={100} /></Form.Group>
            <Form.Group className="mb-3"><Form.Label>Monitor status</Form.Label><CustomReportAllSelectInput value={filters.status} onChange={(value) => setFilter("status", value)} isMulti options={options.status} allLabel="All monitor statuses" placeholder="Monitor status" /></Form.Group>
            <Form.Group className="mb-3"><Form.Label>Ping status</Form.Label><CustomReportAllSelectInput value={filters.ping_status} onChange={(value) => setFilter("ping_status", value)} isMulti options={options.ping_status} allLabel="All ping statuses" placeholder="Ping status" /></Form.Group>
            <Form.Group className="mb-3"><Form.Label>Monitor type</Form.Label><CustomReportAllSelectInput value={filters.kind} onChange={(value) => setFilter("kind", value)} isMulti options={options.kind} allLabel="All monitor types" placeholder="Monitor type" /></Form.Group>
            <Form.Group className="mb-3"><Form.Label>Priority</Form.Label><CustomReportAllSelectInput value={filters.priority} onChange={(value) => setFilter("priority", value)} isMulti options={options.priority} allLabel="All priorities" placeholder="Monitor priority" /></Form.Group>
            <Form.Group className="mb-3"><Form.Label>Search</Form.Label><Form.Control value={filters.search?.[0] || ""} onChange={(event) => setFilter("search", [event.target.value])} placeholder="Search for a name, reference, or description" /></Form.Group>
            <Form.Group className="mb-3"><Form.Label>Display</Form.Label><SelectInput value={[displayMode]} onChange={(value) => setDisplayMode(value[0])} options={[{ value: "table", label: "Table" }, { value: "count", label: "Count" }, { value: "pie", label: "Pie chart" }, { value: "bar", label: "Bar graph" }]} /></Form.Group>
            {displayMode !== "table" && <Form.Group><Form.Label>Group chart by</Form.Label><SelectInput value={[groupBy]} onChange={(value) => setGroupBy(value[0])} options={[{ value: "status", label: "Monitor status" }, { value: "pingStatus", label: "Ping status" }, { value: "kind", label: "Monitor type" }, { value: "priority", label: "Priority" }]} /></Form.Group>}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer><button type="button" className="btn btn-light" onClick={onHide}>Cancel</button><button type="button" className="btn btn-colored" disabled={!title.trim()} onClick={() => onSelect({ title: title.trim(), filters, displayMode, groupBy })}>Save widget</button></Modal.Footer>
    </Modal>
  );
}
